import React, { useState } from "react";
import Dialog from "../GenericComponents/dialog";
interface HandleAnyPopupMessageProps {
    isOpen?: boolean;
    onClose?: () => void;
    title: string
    message: string | React.ReactNode;
    closeAfterSecs?: number,
    Link?: string | null,
    linkText?: string
    customButtons?:{text:string, onClick:()=>void}[]
    hideClose?:boolean,
    textClasses?: string,
    alignLeft?: boolean
}


const HandleAnyPopupMessage: React.FC<HandleAnyPopupMessageProps> = ({isOpen=true, onClose, title, message, closeAfterSecs, Link, linkText="", customButtons=[], hideClose=false, textClasses='', alignLeft = false }) => {

    const [dialogOpen, setDialogOpen] = useState(isOpen);

    if (dialogOpen && closeAfterSecs && closeAfterSecs > 0) {
        setTimeout(() => {
            setDialogOpen(false);
            onClose?.();
        }, closeAfterSecs);
    }

    // const getUIDialogButtons = () => [
    //     {
    //         label: "Close",
    //         onClick: () => {
    //             setDialogOpen(false);
    //             onClose?.();
    //         },
    //         className: "app-button"
    //     }
    // ];

    return (
        <Dialog
            isOpen={isOpen}
            title={title}
            onClose={onClose} 
            className="left-align-text"
            height={'auto'}
            width={'auto'}
            minHeight={88}
            contentStyles={{ height: '100%', overflow: 'hidden' }}
            hideClose={hideClose}
            // buttons={getUIDialogButtons()}
        >
            <div id="app_ajax_page_message_popup" className="panel-popup-window ui-dialog-content ui-widget-content">
                <div className={"padding-small app-ui-dialog "+textClasses}
                    style={ alignLeft ? {textAlign: 'left'} : undefined}>
                    {message} {Link && <a href={Link} onClick={onClose}>{linkText}</a>}
                    <div id="autonextproceed-buttons">
                        {customButtons.map((button, index) => {return <button className="app-button" key={"custom_button_"+title+index} onClick={button.onClick}>{button.text}</button>})}
                    </div>
                </div>
            </div>


        </Dialog>
    );
};

export default HandleAnyPopupMessage;